/**
 * Constants for connection status component
 * Contains text definitions used as prop defaults in BcsConnectionStatus.vue
 */

export const CONNECTION_TEXT_DEFINITIONS = {
  connectionOfflineMessage: {
    title: 'Connection Issue',
    body: 'We detected that you are currently offline or experiencing connection issues. Some features may not work properly until your connection is restored.'
  },
  connectionRestoredMessage: {
    title: 'Connection Restored',
    body: 'Connection restored — reload to refresh data.'
  },
  connectionSlowMessage: {
    title: 'Slow Connection',
    body: 'Your internet connection appears to be slow. This may affect the performance of some features. Please check your network connection.'
  }
};
